<template>
  <ion-page class="mixture">
    <common-background
      :title="'混组检查  ' + mixStep"
      router-type="modal"
      @router-back="onConfirmCloseWrap"
    >
      <template #default>
        <div class="word-box">
          <VideoHeight />
          <div
            v-show="!showButtons"
            id="mixture_page_id"
            class="mixture_page"
            :class="{ 'scroll-disabled': !canScroll() }"
            @scroll="ionScroll($event)"
            @wheel="preventScroll"
            @touchmove="preventScroll"
          >
            <div v-if="dataList?.length" class="word-list">
              <template v-for="(item, index) in dataList" :key="index">
                <div
                  v-if="item.isShow"
                  class="word-list_item flex-row justify-between"
                  @click="onShowParaphrase(index, item, $event)"
                >
                  <div class="item-word flex-row align-center flex-wrap">
                    <span
                      v-show="!item.showParaphrase"
                      class="word-style switch-font-size-video flex-row align-center mr-5"
                    >
                      {{ item.word }}
                    </span>
                    <div
                      v-show="item.showParaphrase"
                      class="cnword flex-row word-style gray-color flex-wrap"
                    >
                      <span class="english-word switch-font-size-video">{{ item.word }}</span
                      ><span style="font-size: 16px">{{ item.paraphrase }}</span>
                    </div>
                  </div>
                  <div class="item-icon flex-row align-center">
                    <img
                      v-if="item.audioIconShow || showOneButton"
                      src="@/assets/teacher_index/version5/teacher_button.png"
                      class="img-icon cursor-pointer mr-4"
                      @click.stop="
                        playUniversalFormulaAudioWrap(
                          item.word,
                          item.paraphrase,
                          50 * speedRate,
                          index
                        )
                      "
                    />
                    <div
                      v-if="showOneButton"
                      class="inner-box flex-row align-center"
                      @click.stop="onSelect2(index, item)"
                    >
                      <img
                        class="test-icon cursor-pointer"
                        src="@/assets/teacher_index/version5/scissors_right.svg"
                        alt=""
                      />
                    </div>

                    <div v-if="!showOneButton" class="inner-box" @click.stop="onYes2(index, item)">
                      <img
                        class="test-icon cursor-pointer mr-4"
                        src="@/assets/teacher_index/version5/scissors_right.svg"
                        alt=""
                      />
                    </div>

                    <div v-if="!showOneButton" class="inner-box" @click.stop="onNot(index, item)">
                      <img
                        class="test-icon cursor-pointer"
                        src="@/assets/teacher_index/version5/scissors_mistake.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div v-else class="mixture-empty">
              <!--            <div class="mixture-empty-tip" :class="{'onlyNotNumClass': selectNotNum && !selectYesNum}">-->
              <!--              <div class="mixture-empty-tip__title">点击继续</div>-->
              <!--              <img class="mixture-empty-tip__img" :src="getBrandImageUrl('speed/green_down_icon.png')" alt="点击继续">-->
              <!--            </div>-->
              <!--            <div v-show="selectNotNum" class="mixture-empty-tip notNumClass">-->
              <!--              <div class="mixture-empty-tip__title">点击继续</div>-->
              <!--              <img class="mixture-empty-tip__img" :src="getBrandImageUrl('speed/red_down_icon.png')" alt="点击继续">-->
              <!--            </div>-->
            </div>
          </div>
          <div
            v-show="showButtons"
            class="mixture_page encourage-padding flex-column justify-between"
          >
            <div class="emoji flex-column align-center">
              <img :src="getBrandImageUrl('speed/encourage_bg.png')" alt="" />
            </div>
            <div class="flex-column">
              <ion-button class="button-outline mb-3" shape="round" @click="onReCheck"
                >重新检查
              </ion-button>
              <ion-button
                v-show="!isEnd && !isOver"
                class="green_bg mb-3"
                shape="round"
                @click="backSign"
                >下一组
              </ion-button>
              <ion-button
                v-show="isEnd && !isOver"
                class="green_bg mb-3"
                shape="round"
                @click="onMixtureAll(step)"
                >混组全部
              </ion-button>
              <ion-button v-show="isOver" class="green_bg mb-3" shape="round" @click="openAfterTest"
                >训后检测
              </ion-button>
            </div>
          </div>
        </div>
      </template>
      <template #rightTitle>
        <switch-font-size />
        <speed-switch />
      </template>
    </common-background>
    <div v-show="!showButtons" class="mixture_bottom" style="height: 75px !important">
      <div class="flex-row justify-evenly align-center">
        <div v-show="showOneButton" class="mixture_box" @click="onRestore">
          <img
            v-show="selectNum == 0"
            src="@/assets/teacher_index/version5/empty_green_box.svg"
            alt=""
          />
          <img
            v-show="selectNum != 0"
            src="@/assets/teacher_index/version5/fill_green_box.svg"
            alt=""
          />
          <span class="box-text true-text">{{ selectNum }}</span>
        </div>
        <div v-show="!showOneButton && selectYesNum == 0" class="mixture_box" @click="onYesRestore">
          <img src="@/assets/teacher_index/version5/empty_green_box.svg" alt="" />
          <span class="box-text true-text">{{ selectYesNum }}</span>
        </div>
        <div v-show="!showOneButton && selectYesNum != 0" class="mixture_box" @click="onYesRestore">
          <img src="@/assets/teacher_index/version5/fill_green_box.svg" alt="" />
          <span class="box-text true-text">{{ selectYesNum }}</span>
        </div>
        <div v-show="!showOneButton && selectNotNum == 0" class="mixture_box" @click="onNotRestore">
          <img src="@/assets/teacher_index/version5/empty_red_box.svg" alt="" />
          <span class="box-text false-text">{{ selectNotNum }}</span>
        </div>
        <div v-show="!showOneButton && selectNotNum != 0" class="mixture_box" @click="onNotRestore">
          <img src="@/assets/teacher_index/version5/fill_red_box.svg" alt="" />
          <span class="box-text false-text">{{ selectNotNum }}</span>
        </div>
      </div>
    </div>
  </ion-page>
</template>

<script>
import { alertController, IonButton, IonPage, modalController } from "@ionic/vue"

import {
  arrowBackCircle,
  arrowForwardCircle,
  arrowUndo,
  checkmarkCircle,
  chevronBackOutline,
  closeCircle,
  gitCompare,
  reorderFour,
} from "ionicons/icons"

import { BRAND_IMAGES, getBrandImageUrl } from "@/js/brandImages.ts"
import CommonBackground from "@/components/CommonBackground.vue"
import { playUniversalFormulaAudio } from "@/js/commonMethod"
import SpeedSwitch from "@/components/speedSwitch.vue"
import { useStorage } from "@vueuse/core"
import mqttServer from "@/js/mqtt"
import pagesQueue from "@/js/pagesQueue"
import PageDialog from "@/components/PageDialog.vue"
import VideoHeight from "@/views/liveVideo/components/videoHeight.vue"
import { debounce } from "lodash"
import SwitchFontSize from "@/views/liveVideo/components/switchFontSize.vue"

const mixStepMap = ["0", "1", "1,2", "1,2,3", "4", "4,5", "4,5,6", "7", "7,8", "7,8,9"]
const speedRate = useStorage("xf-speed", 1, localStorage)

export default {
  name: "SpeedMixture",
  components: {
    SpeedSwitch,
    CommonBackground,
    IonPage,
    IonButton,
    VideoHeight,
    SwitchFontSize,
  },
  props: ["studentId", "step"],
  setup() {
    // 获取会话存储中学生和老师单词列表高度
    const studentOffsetHeight = useStorage("studentOffsetHeight", "", sessionStorage)
    const teacherOffsetHeight = useStorage("teacherOffsetHeight", "", sessionStorage)
    // 获取会话存储中学生和老师单词列表宽度
    const studentOffsetWidth = useStorage("studentOffsetWidth", "", sessionStorage)
    const teacherOffsetWidth = useStorage("teacherOffsetWidth", "", sessionStorage)
    return {
      checkmarkCircle,
      closeCircle,
      chevronBackOutline,
      gitCompare,
      arrowUndo,
      reorderFour,
      arrowBackCircle,
      arrowForwardCircle,
      speedRate,
      studentOffsetHeight,
      teacherOffsetHeight,
      studentOffsetWidth,
      teacherOffsetWidth,
    }
  },

  data() {
    return {
      canScrollPermission: true, // 添加响应式的滚动权限状态
      instructData: {
        //信令传递消息
        project: "lxll",
        page: "teachIndex",
        module: "Mixture",
        pageModle: true,
        userType: 1,
        data: null,
        fn: "",
        param: null,
        timestamp: " ",
      },
      timer: null, //滚动防抖
      debouncedScrollHandler: null, // 防抖滚动处理函数
      dataList: [],
      historySelectList: [], // 巡查官使用该数组确保展示同步
      historySelectListYes: [], // 巡查官使用该数组确保展示同步-选择yes的单词
      historySelectListNot: [], // 巡查官使用该数组确保展示同步-选择no的单词
      showButtons: false, //剪纸盒步骤
      showOneButton: true, //显示一个操作按钮
      isEnd: false, //控制"混组全部"按钮显示
      isOver: false, //控制"全部结束"按钮显示
      mixStep: undefined,
      selectItems: [],
      selectYesItems: [],
      selectNotItems: [],
      selectNum: 0,
      selectYesNum: 0,
      selectNotNum: 0,
      brandImages: BRAND_IMAGES,
      afterTestModal: null,
    }
  },
  watch: {
    afterTestModal() {
      if (this.afterTestModal) {
        this.listenModalDismiss()
      }
    },
  },

  mounted() {
    this.userinfo = this.store.getUser()

    // 初始化滚动权限状态
    this.updateScrollPermission()

    // 添加权限变化监听器
    mqttServer.addPermissionListener(this.updateScrollPermission)

    this.initQuery()

    // 初始化防抖滚动处理函数
    this.debouncedScrollHandler = debounce((e) => {
      // 只有有滚动权限的用户才能发送滚动消息
      if (this.canScroll()) {
        mqttServer.pushMsg(this.instructData, {
          params: [JSON.parse(JSON.stringify(e.target.scrollTop))],
          fn: "handleScroll",
          msgType: "function",
          udp: true,
        })
      }
    }, 500)

    mqttServer.onMqttMessage(this.instructData.module, this.onMessageReceived)
    // sessionStorage.setItem('pageFlag', 'false')

    // 巡查官不执行后续代码
    if (this.userinfo.isAdmin) return
    // 等待1秒iframe浏览器渲染完成，设置单词列表高度
    setTimeout(() => {
      let dom = document.getElementById("mixture_page_id")
      if (this.studentOffsetHeight > this.teacherOffsetHeight) {
        dom.style.height = this.teacherOffsetHeight + "px"
      } else {
        dom.style.height = this.studentOffsetHeight + "px"
      }
      if (this.studentOffsetWidth > this.teacherOffsetWidth) {
        dom.style.width = this.teacherOffsetWidth + "px"
      } else {
        dom.style.width = this.studentOffsetWidth + "px"
      }
    }, 1000)
  },
  beforeUnmount() {
    if (this.debouncedScrollHandler) {
      this.debouncedScrollHandler.cancel()
    }
    // 移除权限变化监听器
    mqttServer.removePermissionListener(this.updateScrollPermission)
  },

  methods: {
    playUniversalFormulaAudioWrap(word, paraphrase, speedRate, idx) {
      mqttServer
        .pushMsg(this.instructData, {
          params: [word, paraphrase, speedRate, idx],
          fn: "playUniversalFormulaAudio",
          msgType: "function",
        })
        .then(async () => {
          this.playUniversalFormulaAudio(word, paraphrase, speedRate, idx)
          // this.autoShowClickGifSync(idx)
        })
    },
    onConfirmCloseWrap() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "onConfirmCloseSync",
          msgType: "function",
        })
        .then(async () => {
          this.onConfirmCloseSync()
        })
    },
    async onConfirmCloseSync() {
      const modal = await modalController.create({
        component: PageDialog,
        id: "PageDialog",
        backdropDismiss: false,
        componentProps: { message: "确认回退吗?", type: "hasCancel" },
        cssClass: "center_modal_controller_class3",
      })
      await modal.present()
      const { data } = await modal.onDidDismiss()
      if ("NEXT" === data) {
        modalController.dismiss()
        pagesQueue.queuePageChange("Nine")
      }
    },
    playUniversalFormulaAudio,
    getBrandImageUrl,
    doRefresh(RefreshAnimationEvent) {
      this.tools.closeRefreshAnimation(RefreshAnimationEvent, 2000)
      this.initQuery(RefreshAnimationEvent)
    },

    backSign() {
      mqttServer
        .pushMsg(this.instructData, {
          params: [],
          fn: "backSignSync",
          msgType: "function",
        })
        .then(async () => {
          pagesQueue.queuePageChange("Sign", {
            studentId: this.studentId,
            step: this.step + 1,
          })
        })
    },

    backSignSync() {
      // modalController.dismiss({ status: "TO_SIGN" })
      pagesQueue.queuePageChange("Sign", {
        studentId: this.studentId,
        step: this.step + 1,
      })
    },

    // 检查当前用户是否有发送权限（即是否有滚动权限）
    canScroll() {
      const appointment = this.store.getAppointment()
      // 如果是巡查官，总是可以滚动,或者不是视频课，也能滚动
      if ((this.userinfo && this.userinfo.isAdmin) || appointment.videoFlag != 1) {
        return true
      }
      // 使用响应式的权限状态
      return this.canScrollPermission
    },

    // 更新滚动权限状态
    updateScrollPermission() {
      this.canScrollPermission = mqttServer.getCanSend()
    },

    // 滚动事件监听
    ionScroll(e) {
      // 检查是否有滚动权限
      if (!this.canScroll()) {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
      this.debouncedScrollHandler(e)
    },

    // 阻止滚动事件
    preventScroll(e) {
      if (!this.canScroll()) {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
    },

    //处理滚动事件
    handleScroll(e) {
      let dom = document.getElementById("mixture_page_id")
      // let domHeight = document.getElementById('scroll-wrap-article').clientHeight
      // let scrollHeight = e * domHeight
      dom.scrollTop = e
    },

    // 关闭混组检查页面
    async onConfirmCloseIn() {
      // mqttServer
      //   .pushMsg(this.instructData, {
      //     fn: "onConfirmCloseInSync",
      //     msgType: "function",
      //   })
      //   .then(async () => {
      //     const alert = await alertController.create({
      //       header: this.$t("提示"),
      //       message: this.$t("确认回退吗？"),
      //       backdropDismiss: false, //点击背景不关闭
      //       buttons: [
      //         {
      //           text: this.$t("取消"),
      //           handler: () => {
      //             mqttServer
      //               .pushMsg(this.instructData, {
      //                 fn: "cancelAlrtController",
      //                 msgType: "function",
      //               })
      //               .then(() => {
      //                 this.cancelAlrtController()
      //               })
      //           },
      //         },
      //         {
      //           text: this.$t("确定"),
      //           handler: () => {
      //             mqttServer
      //               .pushMsg(this.instructData, {
      //                 fn: "cancelAllModel",
      //                 msgType: "function",
      //               })
      //               .then(() => {
      //                 this.cancelAllModel()
      //               })
      //           },
      //         },
      //       ],
      //     })
      //     await alert.present()
      //   })
    },
    async onConfirmCloseInSync() {
      // const alert = await alertController.create({
      //   header: this.$t("提示"),
      //   message: this.$t("确认回退吗？"),
      //   backdropDismiss: false, //点击背景不关闭
      //   buttons: [
      //     {
      //       text: this.$t("取消"),
      //     },
      //     {
      //       text: this.$t("确定"),
      //     },
      //   ],
      // })
      // await alert.present()
    },

    // 关闭提示弹框
    cancelAlrtController() {
      alertController.dismiss()
    },

    // 关闭模态框
    cancelModel() {
      pagesQueue.queuePagePop()
      modalController.dismiss()
    },

    // 关闭提示弹框和模态框
    cancelAllModel() {
      this.cancelAlrtController()
      this.cancelModel()
    },

    // 处理消息
    async onMessageReceived(msg) {
      // 确保 msg.fn 是 this 上的有效函数
      if (typeof this[msg.fn] !== "function") {
        throw new Error(`Method ${msg.fn} is not a function`)
      }

      try {
        // 根据 params 是否为数组决定如何调用方法
        if (Array.isArray(msg.params)) {
          await this[msg.fn](...msg.params)
        } else {
          await this[msg.fn](msg.params)
        }
        return true
      } catch (error) {
        console.error("Error executing method:", error)
        throw error // 或者根据需要处理错误
      }
    },

    //混组检查 异步
    async openAfterTestSync() {
      sessionStorage.setItem("pageFlag", "false")

      pagesQueue.queuePagePush({
        page: "AfterTest",
        params: {
          studentId: this.studentId,
          showCloseButton: false,
          notForce: true,
        },
      })

      // const modal = await modalController.create({
      //   component: AfterTestPage,
      //   componentProps: {
      //     studentId: this.studentId,
      //     showCloseButton: false,
      //     notForce: true,
      //   },
      //   cssClass: "modal_controller_class",
      // })
      //
      // await modal.present()
      // const { data } = await modal.onDidDismiss()
      // if (data) {
      //   await modalController.dismiss({ ...data })
      // }
    },

    //混组检查
    async openAfterTest() {
      mqttServer
        .pushMsg(this.instructData, {
          params: {
            studentId: this.studentId,
            showCloseButton: false,
            notForce: true,
          },
          fn: "openAfterTestSync",
          msgType: "function",
        })
        .then(async () => {
          this.openAfterTestSync()
        })
      // const modal = await modalController.create({
      //   component: AfterTestPage,
      //   componentProps: {
      //     studentId: this.studentId,
      //     showCloseButton: false,
      //     notForce: true,
      //   },
      //   cssClass: "modal_controller_class",
      // });
      // await modal.present();
      // const { data } = await modal.onDidDismiss();
      // if (data) {
      //   await modalController.dismiss({ ...data });
      // }
    },

    async listenModalDismiss() {
      const { data } = await this.afterTestModal.onDidDismiss()
      if ("NEXT" === data) {
        pagesQueue.queuePagePop()
        await modalController.dismiss("NEXT")
      } else {
        pagesQueue.queuePagePop()
        await modalController.dismiss()
      }
    },

    //重置数据
    reset() {
      this.showButtons = false //剪纸盒步骤
      this.showOneButton = true //混组检查第一步
      this.isEnd = false //显示终点按钮
      this.selectItems = []
      this.selectYesItems = []
      this.selectNotItems = []
      this.selectNum = 0
      this.selectYesNum = 0
      this.selectNotNum = 0
      this.historySelectList = []
      this.historySelectListYes = []
      this.historySelectListNot = []
    },

    //重新检测异步
    onReCheckSync() {
      if (
        this.selectYesItems.length > 0 &&
        this.dataList.filter((item) => item.isShow).length == 0
      ) {
        for (let i = 0; i < this.dataList.length; i++) {
          this.dataList[i]["audioIconShow"] = false
          this.dataList[i].isShow = true
        }
        this.showButtons = false //剪纸盒步骤
        this.selectItems = []
        this.selectYesItems = []
        this.selectNotItems = []
        this.selectNum = 0
        this.selectYesNum = 0
        this.selectNotNum = 0
        this.historySelectList = []
        this.historySelectListYes = []
        this.historySelectListNot = []
      }
    },

    //重新检测
    onReCheck() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "onReCheckSync",
          msgType: "function",
        })
        .then(() => {
          this.onReCheckSync()
        })
    },

    //还原中间盒子 异步
    onRestoreSync(adminPass, historySelectList = [], isShowParaphraseIndex = []) {
      if (this.userinfo.isAdmin && historySelectList.length > 0) {
        // 根据onSelect2List的索引，把dataList中isShow为false的单词的showParaphrase设置为false，clickStep设置为1
        for (let i = 0; i < historySelectList.length - 1; i++) {
          if (this.dataList[historySelectList[i]].isShow) {
            this.dataList[historySelectList[i]].showParaphrase = false
            this.dataList[historySelectList[i]].clickStep = 1
            this.selectItems.push(this.dataList[historySelectList[i]])
            this.selectNum++
            this.dataList[historySelectList[i]].isShow = false
          }
        }
        if (isShowParaphraseIndex.length > 0) {
          isShowParaphraseIndex.forEach((index) => {
            this.dataList[index].isShow = true
            this.dataList[index].clickStep = 3
            this.dataList[index].showParaphrase = true
            this.selectItems.forEach((item) => {
              if (item.vocabularyId == this.dataList[index].vocabularyId) {
                this.selectItems.splice(this.selectItems.indexOf(item), 1)
              }
            })
          })
          this.selectNum = this.selectItems.length
        }
      }
      if (this.userinfo.isAdmin && adminPass && this.selectItems.length == 0) {
        for (let i = 0; i < this.dataList.length; i++) {
          if (this.dataList[i].isShow) {
            this.dataList[i].showParaphrase = false
            this.dataList[i].clickStep = 1
            this.dataList[i].isShow = false
            this.selectItems.push(this.dataList[i])
          }
        }
        this.selectNum = this.selectItems.length
      }
      if (this.selectItems.length > 0 && this.dataList.filter((item) => item.isShow).length == 0) {
        this.showOneButton = false
        for (let i = 0; i < this.dataList.length; i++) {
          this.dataList[i].isShow = true
          this.dataList[i].clickStep = 1
          this.dataList[i].showParaphrase = false
        }
        this.selectItems = []
        this.selectNum = 0
        this.historySelectList = []
        this.historySelectListYes = []
        this.historySelectListNot = []
      }
    },

    //还原中间盒子
    onRestore() {
      const adminPass =
        this.selectItems.length > 0 && this.dataList.filter((item) => item.isShow).length == 0
      const isShowParaphraseIndex = []
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].isShow && this.dataList[i].showParaphrase) {
          isShowParaphraseIndex.push(i)
        }
      }
      mqttServer
        .pushMsg(this.instructData, {
          params: [adminPass, this.historySelectList, isShowParaphraseIndex],
          fn: "onRestoreSync",
          msgType: "function",
        })
        .then(() => {
          this.onRestoreSync()
        })
    },

    //还原回的盒子 异步
    onYesRestoreSync(historySelectListYes = [], historySelectListNot = []) {
      if (this.userinfo.isAdmin) {
        this.showOneButton = false
        if (historySelectListYes.length > 0 && this.selectYesItems.length == 0) {
          for (let i = 0; i < historySelectListYes.length; i++) {
            if (this.dataList[historySelectListYes[i]].clickStep == 1) {
              this.dataList[historySelectListYes[i]].showParaphrase = false
              this.dataList[historySelectListYes[i]].clickStep = 1
              this.dataList[historySelectListYes[i]]["audioIconShow"] = false
              this.selectYesItems.push(this.dataList[historySelectListYes[i]])
              this.dataList[historySelectListYes[i]].isShow = false
            }
          }
          this.selectYesNum = this.selectYesItems.length
        }
        if (historySelectListNot.length > 0 && this.selectNotItems.length == 0) {
          for (let i = 0; i < historySelectListNot.length; i++) {
            this.dataList[historySelectListNot[i]].showParaphrase = false
            this.selectNotItems.push(this.dataList[historySelectListNot[i]])
            this.dataList[historySelectListNot[i]].isShow = false
          }
          this.selectNotNum = this.selectNotItems.length
        }
      }
      if (this.selectYesItems.length > 0) {
        for (let i = 0; i < this.dataList.length; i++) {
          if (
            this.dataList[i].vocabularyId ==
            this.selectYesItems[this.selectYesItems.length - 1].vocabularyId
          ) {
            this.dataList[i].audioIconShow = false
            this.dataList[i].isShow = true
            this.dataList[i].clickStep = 1
            this.selectYesItems.pop()
            this.historySelectListYes.pop()
            break
          }
        }
        this.selectYesNum = this.selectYesItems.length
      }
    },

    //还原回的盒子
    onYesRestore() {
      mqttServer
        .pushMsg(this.instructData, {
          params: [this.historySelectListYes, this.historySelectListNot],
          fn: "onYesRestoreSync",
          msgType: "function",
        })
        .then(() => {
          this.onYesRestoreSync()
        })
    },

    //还原不会的盒子 异步
    onNotRestoreSync(historySelectListNot = [], historySelectListYes = []) {
      if (this.userinfo.isAdmin) {
        // 如果是巡查官登录，当陪练进行到该步骤时要变更巡查官的步骤按钮状态
        this.showOneButton = false
        if (historySelectListNot.length > 0 && this.selectNotItems.length == 0) {
          for (let i = 0; i < historySelectListNot.length; i++) {
            this.dataList[historySelectListNot[i]].showParaphrase = false
            this.selectNotItems.push(this.dataList[historySelectListNot[i]])
            this.dataList[historySelectListNot[i]].isShow = false
          }
          this.selectNotNum = this.selectNotItems.length
        }
        if (historySelectListYes.length > 0 && this.selectYesItems.length == 0) {
          for (let i = 0; i < historySelectListYes.length; i++) {
            if (this.dataList[historySelectListYes[i]].clickStep == 1) {
              this.dataList[historySelectListYes[i]].showParaphrase = false
              this.dataList[historySelectListYes[i]].clickStep = 1
              this.dataList[historySelectListYes[i]]["audioIconShow"] = false
              this.selectYesItems.push(this.dataList[historySelectListYes[i]])
              this.dataList[historySelectListYes[i]].isShow = false
            }
          }
          this.selectYesNum = this.selectYesItems.length
        }
      }
      if (this.selectNotItems.length > 0) {
        for (let i = 0; i < this.dataList.length; i++) {
          for (let j = 0; j < this.selectNotItems.length; j++) {
            if (this.dataList[i].vocabularyId == this.selectNotItems[j].vocabularyId) {
              this.dataList[i].isShow = true
              this.dataList[i].audioIconShow = true
              this.dataList[i].clickStep = 1
            }
          }
        }
        this.selectNotItems = []
        this.historySelectListNot = []
        this.selectNotNum = this.selectNotItems.length
      }
    },

    //还原不会的盒子
    onNotRestore() {
      mqttServer
        .pushMsg(this.instructData, {
          params: [this.historySelectListNot, this.historySelectListYes],
          fn: "onNotRestoreSync",
          msgType: "function",
        })
        .then(() => {
          this.onNotRestoreSync()
        })
    },

    //点击读音 异步
    onSelect2Sync(index, item, historySelectList = [], isShowParaphraseIndex = []) {
      const currentItem = this.dataList[index]
      if (!currentItem) return

      if (this.userinfo.isAdmin && historySelectList.length > 0) {
        // 根据onSelect2List的索引，把dataList中isShow为false的单词的showParaphrase设置为false，clickStep设置为1
        for (let i = 0; i < historySelectList.length - 1; i++) {
          if (this.dataList[historySelectList[i]].isShow) {
            this.dataList[historySelectList[i]].showParaphrase = false
            this.dataList[historySelectList[i]].clickStep = 1
            this.selectItems.push(this.dataList[historySelectList[i]])
            this.selectNum++
            this.dataList[historySelectList[i]].isShow = false
          }
        }
        if (isShowParaphraseIndex.length > 0) {
          isShowParaphraseIndex.forEach((index) => {
            this.dataList[index].isShow = true
            this.dataList[index].clickStep = 3
            this.dataList[index].showParaphrase = true
            this.selectItems.forEach((item) => {
              if (item.vocabularyId == this.dataList[index].vocabularyId) {
                this.selectItems.splice(this.selectItems.indexOf(item), 1)
              }
            })
          })
          this.selectNum = this.selectItems.length
        }
        this.dataList[index] = item
        //第一遍只发音
        if (item.clickStep == 1) {
          item["playbackRate"] = speedRate.value
          this.playSoundTemp(item)
          item.showParaphrase = true
          item.clickStep = 3
        }

        //第三遍消失
        else if (item.clickStep == 3) {
          item.showParaphrase = false
          item.clickStep = 1
          this.selectItems.push(item)
          this.selectNum++
          // this.dataList.splice(index, 1)
          item.isShow = false
          this.audio(this.voice_path + "right.mp3")
        }
      } else {
        //第一遍只发音
        if (currentItem.clickStep == 1) {
          currentItem["playbackRate"] = speedRate.value
          item["playbackRate"] = speedRate.value
          this.playSoundTemp(item)
          currentItem.showParaphrase = true
          currentItem.clickStep = 3
        }

        //第三遍消失
        else if (currentItem.clickStep == 3) {
          currentItem.showParaphrase = false
          currentItem.clickStep = 1
          this.selectItems.push(currentItem)
          // this.dataList.splice(index, 1)
          this.dataList[index].isShow = false
          this.dataList[index].clickStep = 1
          this.audio(this.voice_path + "right.mp3")
          // this.selectNum++
          // 通过循环dataList中isShow为false的单词,计算出selectNum的数量
          this.selectNum = this.dataList.filter((item) => !item.isShow).length
        }
      }
    },

    //自动带读模式，第一遍学习每个单词需要点击三次
    //第一遍打钩  重写，2024-02-27
    //点击3次，第一次只发音，第二次显示中英文，第三次消失
    onSelect2(index, item) {
      const isShowParaphraseIndex = []
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].isShow && this.dataList[i].showParaphrase) {
          isShowParaphraseIndex.push(i)
        }
      }
      // 去重
      this.historySelectList.push(index)
      this.historySelectList = [...new Set(this.historySelectList)]
      try {
        mqttServer
          .pushMsg(this.instructData, {
            params: [index, item, this.historySelectList, isShowParaphraseIndex],
            fn: "onSelect2Sync",
            msgType: "function",
          })
          .then(() => {
            this.onSelect2Sync(index, item)
          })
      } catch {
        this.historySelectList.pop()
      }
    },

    onYes2Sync(index, item, historySelectListYes = [], historySelectListNot = []) {
      const currentItem = this.dataList[index]
      if (this.userinfo.isAdmin) {
        this.showOneButton = false
        if (historySelectListYes.length > 0 && this.selectYesItems.length == 0) {
          for (let i = 0; i < historySelectListYes.length - 1; i++) {
            if (this.dataList[historySelectListYes[i]].clickStep == 1) {
              this.dataList[historySelectListYes[i]].showParaphrase = false
              this.dataList[historySelectListYes[i]].clickStep = 1
              this.dataList[historySelectListYes[i]]["audioIconShow"] = false
              this.selectYesItems.push(this.dataList[historySelectListYes[i]])
              this.selectYesNum = this.selectYesItems.length
              // this.dataList.splice(index, 1)
              this.dataList[historySelectListYes[i]].isShow = false
            }
          }
        }
        if (historySelectListNot.length > 0 && this.selectNotItems.length == 0) {
          for (let i = 0; i < historySelectListNot.length; i++) {
            this.dataList[historySelectListNot[i]].showParaphrase = false
            this.selectNotItems.push(this.dataList[historySelectListNot[i]])
            this.selectNotNum = this.selectNotItems.length
            // this.dataList.splice(index, 1)
            this.dataList[historySelectListNot[i]].isShow = false
          }
        }
      }
      //第一遍只发音
      if (currentItem.clickStep == 1) {
        // item["playbackRate"] = speedRate.value;
        // this.playSoundTemp(item);
        currentItem.showParaphrase = false
        currentItem.clickStep = 1
        currentItem["audioIconShow"] = false
        const isDuplicate = this.selectYesItems.some(
          (item) => item.vocabularyId == currentItem.vocabularyId
        )
        if (!isDuplicate) {
          this.selectYesItems.push(currentItem)
        }
        this.selectYesNum = this.selectYesItems.length
        // this.dataList.splice(index, 1)
        this.dataList[index].isShow = false
        this.audio(this.voice_path + "right.mp3")
        if (
          this.dataList.filter((item) => item.isShow).length == 0 &&
          this.selectNotItems.length == 0
        ) {
          this.showButtons = true //混组检查
        }
      }
    },

    onYes2(index, item) {
      // 检查historySelectListNot中是否包含当前单词的index,如果存在则不添加到historySelectListYes中
      const isDuplicate = this.historySelectListNot.some((item) => item == index)
      if (isDuplicate) {
        return
      }
      this.historySelectListYes.push(index)
      this.historySelectListYes = [...new Set(this.historySelectListYes)]
      try {
        mqttServer
          .pushMsg(this.instructData, {
            params: [index, item, this.historySelectListYes, this.historySelectListNot],
            fn: "onYes2Sync",
            msgType: "function",
          })
          .then(() => {
            this.onYes2Sync(index, item)
          })
      } catch {
        this.historySelectListYes.pop()
      }
    },

    //加入不会的盒子
    onNotSync(index, item, historySelectListNot = [], historySelectListYes = []) {
      const currentItem = this.dataList[index]
      if (this.userinfo.isAdmin) {
        this.showOneButton = false
        if (historySelectListNot.length > 0 && this.selectNotItems.length == 0) {
          for (let i = 0; i < historySelectListNot.length - 1; i++) {
            this.dataList[historySelectListNot[i]].showParaphrase = false
            this.selectNotItems.push(this.dataList[historySelectListNot[i]])
            this.selectNotNum = this.selectNotItems.length
            // this.dataList.splice(index, 1)
            this.dataList[historySelectListNot[i]].isShow = false
          }
        }
        if (historySelectListYes.length > 0 && this.selectYesItems.length == 0) {
          for (let i = 0; i < historySelectListYes.length; i++) {
            if (this.dataList[historySelectListYes[i]].clickStep == 1) {
              this.dataList[historySelectListYes[i]].showParaphrase = false
              this.dataList[historySelectListYes[i]].clickStep = 1
              this.dataList[historySelectListYes[i]]["audioIconShow"] = false
              this.selectYesItems.push(this.dataList[historySelectListYes[i]])
              this.selectYesNum = this.selectYesItems.length
              // this.dataList.splice(index, 1)
              this.dataList[historySelectListYes[i]].isShow = false
            }
          }
        }
      }
      currentItem.showParaphrase = false
      const isDuplicate = this.selectNotItems.some(
        (item) => item.vocabularyId == currentItem.vocabularyId
      )
      if (!isDuplicate) {
        this.selectNotItems.push(currentItem)
      }
      this.selectNotNum = this.selectNotItems.length
      // this.dataList.splice(index, 1)
      this.dataList[index].isShow = false
      this.audio(this.voice_path + "err.mp3")
    },

    //加入不会的盒子
    onNot(index, item) {
      // 检查historySelectListYes中是否包含当前单词的index,如果存在则不添加到historySelectListNot中
      const isDuplicate = this.historySelectListYes.some((item) => item == index)
      if (isDuplicate) {
        return
      }
      this.historySelectListNot.push(index)
      this.historySelectListNot = [...new Set(this.historySelectListNot)]
      try {
        mqttServer
          .pushMsg(this.instructData, {
            params: [index, item, this.historySelectListNot, this.historySelectListYes],
            fn: "onNotSync",
            msgType: "function",
          })
          .then(() => {
            this.onNotSync(index, item)
          })
      } catch {
        this.historySelectListNot.pop()
      }
    },

    //控制释义显示
    onShowParaphraseSync(index, item) {
      const currentItem = this.dataList[index]

      currentItem["playbackRate"] = speedRate.value
      this.playSoundTemp(currentItem)
      for (let i = 0; i < this.dataList.length; i++) {
        if (index == i) {
          this.dataList[i].showParaphrase = !item.showParaphrase
        } else {
          this.dataList[i].showParaphrase = false
        }
      }
    },

    //控制释义显示
    onShowParaphrase(index, item) {
      mqttServer
        .pushMsg(this.instructData, {
          params: [index, item],
          fn: "onShowParaphraseSync",
          msgType: "function",
        })
        .then(() => {
          this.onShowParaphraseSync(index, item)
        })
      //this.playSound(item.word);
    },

    queryVocabularySync(res, RefreshAnimationEvent) {
      if (res.data.success) {
        this.isEnd = res.data.isEnd
        for (let i = 0; i < res.data.list.length; i++) {
          res.data.list[i].status = 1
          res.data.list[i].isShow = true
          res.data.list[i].showParaphrase = false
          res.data.list[i].clickStep = 1
        }

        //打乱顺序
        // res.data.list.sort(function () {
        //   return 0.5 - Math.random();
        // });

        this.dataList = res.data.list

        // mqttServer.pushMsg(this.instructData, {
        //   params: [
        //     this.step,
        //     RefreshAnimationEvent,
        //     {
        //       list: [...res.data.list],
        //       isEnd: res.data.isEnd,
        //     },
        //   ],
        //   fn: "queryVocabulary",
        //   msgType: "function",
        // })

        sessionStorage.setItem("pageFlag", "true")

        if (RefreshAnimationEvent) {
          RefreshAnimationEvent.target.complete()
        }
      }
    },

    //查询出需要练习的词汇
    queryVocabulary(step, RefreshAnimationEvent) {
      this.ajax
        .get("/vocabulary/queryMixtureWords?studentId=" + this.studentId + "&pageNum=" + step)
        .then((res) => {
          if (this.userinfo.isAdmin) {
            this.queryVocabularySync(res, RefreshAnimationEvent)
          }
          mqttServer
            .pushMsg(this.instructData, {
              params: [res, RefreshAnimationEvent],
              fn: "queryVocabularySync",
              msgType: "function",
            })
            .then(() => {
              this.queryVocabularySync(res, RefreshAnimationEvent)
            })
        })
    },

    mixtureAllSync(res) {
      if (res.data.success) {
        this.isOver = true
        this.reset()
        for (let i = 0; i < res.data.list.length; i++) {
          res.data.list[i].status = 1
          res.data.list[i].isShow = true
          res.data.list[i].showParaphrase = false
          res.data.list[i].clickStep = 1
        }

        //打乱顺序
        // res.data.list.sort(function () {
        //   return 0.5 - Math.random();
        // });

        this.dataList = res.data.list
        // mqttServer.pushMsg(this.instructData, {
        //   params: [
        //     RefreshAnimationEvent,
        //     {
        //       list: [...res.data.list],
        //     },
        //   ],
        //   fn: "mixtureAll",
        //   msgType: "function",
        // })

        // if (RefreshAnimationEvent) {
        //   RefreshAnimationEvent.target.complete()
        // }
      }
    },

    //全部混组
    mixtureAll(RefreshAnimationEvent) {
      this.ajax.get("/vocabulary/queryMixtureAllWords?studentId=" + this.studentId).then((res) => {
        // mqttServer
        //   .pushMsg(this.instructData, {
        //     params: [res, RefreshAnimationEvent],
        //     fn: "mixtureAllSync",
        //     msgType: "function",
        //   })
        //   .then(() => {
        //   })
        this.mixtureAllSync(res, RefreshAnimationEvent)
      })
    },

    //全部混组
    onMixtureAllSync() {
      this.mixStep = "全部混组"
      this.mixtureAll()
    }, //---

    onMixtureAll() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "onMixtureAllSync",
          msgType: "function",
        })
        .then(async () => {
          this.onMixtureAllSync()
        })
    },

    initQuery(ev) {
      const iStep = parseInt(this.step)

      if (iStep == 10) {
        this.mixStep = "全部混组"
        if (this.dataList.length == 0) {
          this.mixtureAll(ev)
        } else {
          setTimeout(() => {
            sessionStorage.setItem("pageFlag", "true")
          })
        }
      } else {
        this.mixStep = "第" + mixStepMap[iStep] + "组"

        if (this.dataList.length == 0) {
          this.queryVocabulary(iStep, ev)
        } else {
          setTimeout(() => {
            sessionStorage.setItem("pageFlag", "true")
          })
        }
      }
    },
  },
}
</script>

<style scoped lang="less">
@import "@/assets/common.less";
@import "@/styles/variables.less";

.word-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
}

.mixture {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0 0 5vh;
  user-select: none;
  -webkit-user-select: none;

  &_page {
    width: 100%;
    height: 92%;
    overflow: auto;
    padding: 10px;
    background-color: #ffffff;

    .word-list {
      &_item {
        padding: 15px;
        background-color: var(--page-bg-color);
        border-radius: 2vw;
        margin-bottom: 10px;
        border: 1px solid transparent;
        position: relative;

        .item-word {
          // flex: 1;
          width: 65%;
        }

        .item-icon {
          max-width: 35%;
          flex-shrink: 0;
        }

        .mr-4 {
          margin-right: 10px;
        }

        .english-word {
          margin-right: 5px;
        }

        .left-line {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translate(0, -50%);
          width: 0.8vw;
          height: 60%;
          border-radius: 0.5vw;
          background-color: var(--green-bg-color);
        }

        .word-style {
          // max-width: 70%;
          font-size: var(--font-20);
          word-break: break-all;
          align-items: center;
        }

        .test-icon {
          width: 25px;
          height: 25px;
          flex-shrink: 0;
          transition: transform 0.1s ease-in-out;

          &:active {
            transform: scaleY(0);
            transition: transform 0.1s ease-in-out;
          }
        }

        .img-icon {
          width: 25px;
          height: 25px;
          // margin-left: 10px;
        }
      }

      .item-checked {
        border: 1px solid var(--green-bg-color);
      }
    }

    .statistic {
      color: var(--font-grey-color);
    }

    ion-button::part(native) {
      box-sizing: content-box;
      padding: 1vw 0;
    }
  }

  &-empty {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;

    &-tip {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-bottom: 8vh;

      &__title {
        color: #868f9e;
        font-size: 1rem;
        margin-bottom: 10px;
      }

      &__img {
        width: 25vw;
      }
    }

    .onlyNotNumClass {
      opacity: 0;
    }

    .notNumClass {
      margin-left: 10vw;
    }
  }

  .encourage-padding {
    width: 100%;
    height: 100%;
    padding: 0 5vw;

    .emoji {
      width: 90%;
      margin: 0 auto;
    }
  }

  &_bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 7rem;
    background-color: #ffffff;
    box-shadow: 1px 1px 2px 0 var(--font-grey-color);

    &-content {
      height: 80%;
      padding: 2vh 3vw 0;
    }
  }

  &_box {
    position: relative;
    //width: 8vh;

    img {
      width: 4rem;
    }

    .box-text {
      position: absolute;
      left: 50%;
      top: 16%;
      transform: translate(-50%, -50%);
      color: #ffffff;
      font-weight: 600;
    }

    .true-text {
      color: #0bbb7d;
    }

    .false-text {
      color: #ff3142;
    }
  }

  .inner-box {
    display: flex;
  }
}
</style>
